import { observable } from "mobx";
import FuelTypeLimitationReason from "./fuelTypeLimitationReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class FuelTypeLimitationResponse {
  /**
   * Allowed fuel type ID.
   */
  @observable
  allowedFuelTypeId!: string;

  @observable
  limitationReason!: FuelTypeLimitationReason;
}
